import { createContext, useContext, useEffect, useState } from "react";

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "es", label: "Español", short: "ES", dir: "ltr" },
  { code: "he", label: "עברית", short: "עברית", dir: "rtl" },
];

const STORAGE_KEY = "gh_lang";
const LanguageContext = createContext(null);

function initialLang() {
  const fromUrl = new URLSearchParams(window.location.search).get("lang");
  const saved = fromUrl || localStorage.getItem(STORAGE_KEY);
  return LANGUAGES.some((l) => l.code === saved) ? saved : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(initialLang);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const meta = LANGUAGES.find((l) => l.code === lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.dir;
    localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, busy, setBusy }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
